import { render } from "./ModalProjetosAssociados.vue?vue&type=template&id=a865040c"
import script from "./ModalProjetosAssociados.vue?vue&type=script&lang=js"
export * from "./ModalProjetosAssociados.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__